import React from 'react';
import { Translation, getI18n } from 'react-i18next';
import { Button, Upload } from 'antd';
import { CloudUploadOutlined, LoadingOutlined } from '@ant-design/icons';

import message from '../../../elements/lib/MessageWrapper';

const UploadCSVButton = ({
  isUploading,
  getUploadURL,
  sendCSVMessage,
  ...props
}) => {
  const fileTypes = {
    'text/csv': 'csv',
    'application/vnd.ms-excel': 'csv',
    'application/csv': 'csv',
    'text/x-csv': 'csv',
    'application/x-csv': 'csv',
    'text/comma-separated-values': 'csv',
    'text/x-comma-separated-values': 'csv',
    'text/plain': 'csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  };

  const allowedExtensions = ['csv', 'xlsx'];
  const fileSizeLimit = 1024 * 1024 * 10; // 10MB

  const beforeUpload = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    const isSupportedType =
      Object.keys(fileTypes).includes(file.type) ||
      allowedExtensions.includes(extension);

    if (!isSupportedType) {
      message.error(getI18n().t('imports_csv_form_feedback_file_types'));
    }

    const isUnderLimit = file.size < fileSizeLimit;
    if (!isUnderLimit) {
      message.error(getI18n().t('imports_csv_form_feedback_file_size_limit'));
    }

    return isSupportedType && isUnderLimit;
  };

  const errorMessage = () => {
    message.error(getI18n().t('imports_csv_form_feedback_error'));
  };

  const submit = async (data) => {
    const file = data.file;
    const extension = file.name.split('.').pop().toLowerCase();

    getUploadURL(extension, async (success, res) => {
      if (success) {
        props.upload(res.upload_url, file, async (uploadSuccess) => {
          if (uploadSuccess) {
            const messageData = {
              resource: 1,
              upload_bucket: res.bucket,
              directory: res.directory,
              file_id: res.file_id,
              file_extension: res.file_ext,
            };

            sendCSVMessage(messageData, (messageSuccess) => {
              if (messageSuccess) {
                message.success(
                  getI18n().t('imports_csv_form_feedback_success')
                );
              } else {
                errorMessage();
              }
            });
          } else {
            errorMessage();
          }
        });
      } else {
        errorMessage();
      }
    });
  };
  return (
    <Translation>
      {(t) => (
        <>
          <Upload
            name='import'
            showUploadList={false}
            customRequest={submit}
            beforeUpload={beforeUpload}
          >
            <Button
              size='small'
              icon={isUploading ? <LoadingOutlined /> : <CloudUploadOutlined />}
            >
              {t('action_import')}
            </Button>
          </Upload>
        </>
      )}
    </Translation>
  );
};

export default UploadCSVButton;
